import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import GridWrapper from "../../atoms/GridWrapper"
import Text from "../../atoms/Text"
import RowGrid from "../../atoms/RowGrid"
import Line from "../../atoms/Line"
import styled from "@emotion/styled"
import Title from "../../atoms/Title"
import { sizes, mediumStyles } from "../../constants"
import { withStyles } from "@material-ui/core/styles"

const LocationDescription = () => (
  <Grid>
    <Title fontWeight={"bold"} fontSize={45}>
      Location
    </Title>
    <Line width={280} />
    <GridWrapper style={{ padding: 20 }}>
      <Grid style={{ textAlign: "left" }}>
        <Text bold>〒100-0005</Text>
        <Text bold>東京都千代田区丸の内３丁目４−１</Text>
        <Text bold>新国際ビルヂング 4階</Text>
        <Text hidden>---</Text>
        <Text>JR「有楽町」駅より徒歩2分</Text>
        <Text>都営「日比谷」駅より徒歩4分</Text>
        <Text>東京メトロ「東京」駅より徒歩5分</Text>
      </Grid>
    </GridWrapper>
  </Grid>
)

const LocationMap = ({ width, height }) => {
  return (
    <iframe
      src={
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.02609788382!2d139.7600391152588!3d35.676359380195386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bf00cc5b591%3A0x836288cd284162d3!2z5paw5Zu96Zqb44OT44Or44OC44Oz44Kw!5e0!3m2!1sja!2sjp!4v1552125996942"
      }
      width={width}
      height={height}
      frameborder={0}
      style={{ border: 0 }}
      allowfullscreen
    />
  )
}

const PCContents = () => (
  <Grid container>
    <Grid
      item
      xs={6}
      style={{
        padding: "0 50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LocationDescription />
    </Grid>
    <Grid item xs={6} style={{ textAlign: "left" }}>
      <LocationMap width={480} height={360} />
    </Grid>
  </Grid>
)

const MoblieContents = () => (
  <Grid>
    <Grid style={{ padding: "20px 30px" }}>
      <LocationDescription />
    </Grid>
    <Grid>
      <LocationMap width={320} height={240} />
    </Grid>
  </Grid>
)

class MapContents extends Component {
  render() {
    const { classes } = this.props
    return (
      <GridWrapper style={{ padding: "20px" }}>
        <Grid className={classes.pc}>
          <PCContents />
        </Grid>
        <Grid className={classes.mobile}>
          <MoblieContents />
        </Grid>
      </GridWrapper>
    )
  }
}

export default withStyles(mediumStyles)(MapContents)
